import actions from "./actions";

const initState = {
  idToken: null,
  balance: null,
  sand_capture_key: null,
  prod_capture_key: null,
  email: null,
  name: null,
  error: null,
};

export default function authReducer(state = initState, action) {
  switch (action.type) {
    case actions.LOGIN_SUCCESS:
      return {
        idToken: action.token,
        balance: action.balance,
        sand_capture_key: action.sand_capture_key,
        prod_capture_key: action.prod_capture_key,
        email: action.email,
        name: action.name,
      };
    case actions.REGISTER_ERROR:
      return {
        error: action.error,
      };
    case actions.UNVERIFIED_EMAIL:
      return {
        error: action.error,
      };
    case actions.LOGOUT:
      return initState;
    default:
      return state;
  }
}
